function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Seller-side Main Store submission.
 * One client path for create-overlay, auto-submit, and My Listings.
 *
 * app.options.store.auto_submit_listings — preference (default false)
 * app.options.store.auto_submit_listings_selected — listing-flow question already asked
 */

function ensureStoreOptions(app) {
  if (!app.options || _typeof(app.options) !== 'object') {
    app.options = {};
  }
  if (!app.options.store || _typeof(app.options.store) !== 'object') {
    app.options.store = {};
  }
  return app.options.store;
}
function isAutoSubmitListings(app) {
  return !!ensureStoreOptions(app).auto_submit_listings;
}
function hasAutoSubmitBeenSelected(app) {
  return !!ensureStoreOptions(app).auto_submit_listings_selected;
}
function setAutoSubmitListings(app, enabled) {
  ensureStoreOptions(app).auto_submit_listings = !!enabled;
  app.storage.saveOptions();
}
function isStoreWeb3Active(app) {
  return ensureStoreOptions(app).web3_active === true;
}
function markStoreWeb3Active(app) {
  var _app$storage, _app$storage$saveOpti;
  var store = ensureStoreOptions(app);
  if (store.web3_active === true) {
    return false;
  }
  store.web3_active = true;
  (_app$storage = app.storage) === null || _app$storage === void 0 || (_app$storage$saveOpti = _app$storage.saveOptions) === null || _app$storage$saveOpti === void 0 || _app$storage$saveOpti.call(_app$storage);
  return true;
}
function isSubmitToMainStoreChecked(root) {
  var _root$querySelector;
  var checkbox = root === null || root === void 0 || (_root$querySelector = root.querySelector) === null || _root$querySelector === void 0 ? void 0 : _root$querySelector.call(root, '[data-action="submit-main-store"]');
  return !!(checkbox !== null && checkbox !== void 0 && checkbox.checked);
}
function attachSubmitToMainStoreCheckbox(root, app) {
  var _root$querySelector2;
  var checkbox = root === null || root === void 0 || (_root$querySelector2 = root.querySelector) === null || _root$querySelector2 === void 0 ? void 0 : _root$querySelector2.call(root, '[data-action="submit-main-store"]');
  if (!checkbox) {
    return;
  }
  checkbox.addEventListener('change', function () {
    if (!checkbox.checked) {
      return;
    }
    void offerAutoSubmitOptInIfNeeded(app);
  });
}
var autoSubmitOptInPromise = null;

/**
 * One-time listing-flow question. Not shown when Settings already enabled
 * auto-submit, when the box is unchecked, or after the user has answered.
 * Cancel still submits the current listing; it only skips changing the default.
 */
function offerAutoSubmitOptInIfNeeded(_x) {
  return _offerAutoSubmitOptInIfNeeded.apply(this, arguments);
}
function _offerAutoSubmitOptInIfNeeded() {
  _offerAutoSubmitOptInIfNeeded = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          if (!(isAutoSubmitListings(app) || hasAutoSubmitBeenSelected(app))) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2);
        case 1:
          if (!autoSubmitOptInPromise) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, autoSubmitOptInPromise);
        case 2:
          autoSubmitOptInPromise = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            var confirmed, store;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _context.n = 1;
                  return confirmAutoSubmitOptIn();
                case 1:
                  confirmed = _context.v;
                  store = ensureStoreOptions(app);
                  if (confirmed) {
                    store.auto_submit_listings = true;
                  }
                  store.auto_submit_listings_selected = true;
                  app.storage.saveOptions();
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }))();
          _context2.p = 3;
          _context2.n = 4;
          return autoSubmitOptInPromise;
        case 4:
          _context2.p = 4;
          autoSubmitOptInPromise = null;
          return _context2.f(4);
        case 5:
          return _context2.a(2);
      }
    }, _callee2, null, [[3,, 4, 5]]);
  }));
  return _offerAutoSubmitOptInIfNeeded.apply(this, arguments);
}
function confirmAutoSubmitOptIn() {
  return new Promise(function (resolve) {
    var _document$getElementB, _document$getElementB2;
    if (typeof document === 'undefined') {
      resolve(false);
      return;
    }
    if (document.getElementById('store-auto-submit-prompt')) {
      resolve(false);
      return;
    }
    var wrapper = document.createElement('div');
    wrapper.id = 'store-auto-submit-prompt';
    wrapper.className = 'saito-alert';
    wrapper.innerHTML = "<div id=\"saito-alert-shim\">\n      <div id=\"saito-alert-box\" class=\"saito-overlay-panel compact\">\n        <div class=\"saito-alert-message\">\n          Submit all future listings automatically to the Main Store?\n        </div>\n        <div class=\"saito-button-row\">\n          <button type=\"button\" class=\"saito-button-secondary\" id=\"store-auto-submit-cancel\">Cancel</button>\n          <button type=\"button\" class=\"saito-button-primary\" id=\"store-auto-submit-confirm\">Confirm</button>\n        </div>\n      </div>\n    </div>";
    document.body.appendChild(wrapper);

    // saito-alert.css parks #saito-alert-box at top: -100% until JS slides it in
    // (same as window.salert / window.sconfirm).
    var box = wrapper.querySelector('#saito-alert-box');
    if (box) {
      box.style.top = '1rem';
    }
    var finish = function finish(value) {
      wrapper.remove();
      resolve(value);
    };
    (_document$getElementB = document.getElementById('store-auto-submit-confirm')) === null || _document$getElementB === void 0 || _document$getElementB.addEventListener('click', function (e) {
      e.preventDefault();
      finish(true);
    });
    (_document$getElementB2 = document.getElementById('store-auto-submit-cancel')) === null || _document$getElementB2 === void 0 || _document$getElementB2.addEventListener('click', function (e) {
      e.preventDefault();
      finish(false);
    });
    var confirmBtn = document.getElementById('store-auto-submit-confirm');
    if (confirmBtn) {
      confirmBtn.focus();
    }
  });
}
function refreshSellerListings(mod) {
  var _mod$main, _storefront$isAdminAc;
  var storefront = mod === null || mod === void 0 || (_mod$main = mod.main) === null || _mod$main === void 0 || (_mod$main = _mod$main.manager) === null || _mod$main === void 0 ? void 0 : _mod$main.storefront;
  if (!storefront) {
    return;
  }
  if ((_storefront$isAdminAc = storefront.isAdminActive) !== null && _storefront$isAdminAc !== void 0 && _storefront$isAdminAc.call(storefront)) {
    void storefront.loadAdminPage({
      page: storefront.page || 1
    });
    return;
  }
  if (typeof storefront.reloadInventory === 'function') {
    void storefront.reloadInventory();
  }
}
function submitListingForApproval(app, mod, signature) {
  var sig = String(signature || '').trim();
  return new Promise(function (resolve, reject) {
    var _app$network;
    if (!sig) {
      reject(new Error('Listing signature required'));
      return;
    }
    var peerKey = mod.store_public_key;
    if (!peerKey || !(app !== null && app !== void 0 && (_app$network = app.network) !== null && _app$network !== void 0 && _app$network.sendRequestAsTransaction)) {
      reject(new Error('Store peer unavailable'));
      return;
    }
    app.network.sendRequestAsTransaction('submit-listing', {
      module: 'Store',
      signature: sig
    }, function (response) {
      if (!response || response.err || response.ok === false) {
        reject(new Error((response === null || response === void 0 ? void 0 : response.err) || 'Unable to submit listing'));
        return;
      }
      refreshSellerListings(mod);
      resolve(response);
    }, peerKey);
  });
}
function submitAfterListingRowReady(_x2, _x3, _x4) {
  return _submitAfterListingRowReady.apply(this, arguments);
}
function _submitAfterListingRowReady() {
  _submitAfterListingRowReady = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, mod, signature) {
    var lastErr, attempt, missing, _t;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          lastErr = null;
          attempt = 0;
        case 1:
          if (!(attempt < 5)) {
            _context3.n = 7;
            break;
          }
          _context3.p = 2;
          _context3.n = 3;
          return submitListingForApproval(app, mod, signature);
        case 3:
          return _context3.a(2, _context3.v);
        case 4:
          _context3.p = 4;
          _t = _context3.v;
          lastErr = _t;
          missing = /not found/i.test(String((_t === null || _t === void 0 ? void 0 : _t.message) || ''));
          if (!(!missing || attempt === 4)) {
            _context3.n = 5;
            break;
          }
          throw _t;
        case 5:
          _context3.n = 6;
          return new Promise(function (resolve) {
            return setTimeout(resolve, 350);
          });
        case 6:
          attempt++;
          _context3.n = 1;
          break;
        case 7:
          throw lastErr;
        case 8:
          return _context3.a(2);
      }
    }, _callee3, null, [[2, 4]]);
  }));
  return _submitAfterListingRowReady.apply(this, arguments);
}
function scheduleSubmitAfterListingConfirmed(app, mod, signature) {
  var sig = String(signature || '').trim();
  if (!sig || !(app !== null && app !== void 0 && app.connection)) {
    return;
  }
  var _onLifecycle = function onLifecycle(entry) {
    if (String((entry === null || entry === void 0 ? void 0 : entry.listing_signature) || '') !== sig) {
      return;
    }
    if (entry.phase !== 'complete') {
      return;
    }
    app.connection.off('store-listing-lifecycle', _onLifecycle);
    submitAfterListingRowReady(app, mod, sig)["catch"](function (err) {
      console.warn('Store: submit-listing after create failed', (err === null || err === void 0 ? void 0 : err.message) || err);
      if (typeof siteMessage === 'function') {
        siteMessage('Your listing was created, but it could not be submitted for Store approval. You can submit it from My Listings.', 5000);
      }
    });
  };
  app.connection.on('store-listing-lifecycle', _onLifecycle);
}
module.exports = {
  ensureStoreOptions: ensureStoreOptions,
  isStoreWeb3Active: isStoreWeb3Active,
  markStoreWeb3Active: markStoreWeb3Active,
  isAutoSubmitListings: isAutoSubmitListings,
  hasAutoSubmitBeenSelected: hasAutoSubmitBeenSelected,
  setAutoSubmitListings: setAutoSubmitListings,
  isSubmitToMainStoreChecked: isSubmitToMainStoreChecked,
  attachSubmitToMainStoreCheckbox: attachSubmitToMainStoreCheckbox,
  offerAutoSubmitOptInIfNeeded: offerAutoSubmitOptInIfNeeded,
  submitListingForApproval: submitListingForApproval,
  scheduleSubmitAfterListingConfirmed: scheduleSubmitAfterListingConfirmed
};